// extracted by mini-css-extract-plugin
export default {"skeleton":"A7l_rZWOcqo4mY6BW9CR","wave":"_U_LSQh5wUMiX8kDhs9U","rtlWave":"VOQ6VVyz_EG8IOdgYAqE"};